import React, { ElementType, ReactNode } from 'react';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Flex,
  Icon,
  Text,
} from '@chakra-ui/react';

interface DropdownProps {
  icon?: ElementType;
  children: ReactNode;
  label: string;
}

export const Dropdown: React.FC<DropdownProps> = ({
  icon,
  label,
  children,
  ...props
}) => {
  return (
    <Accordion
      w="100%"
      allowMultiple
      style={{
        borderColor: 'transparent',
      }}
      _hover={{
        bgColor: 'none',
      }}
      {...props}
    >
      <AccordionItem>
        <AccordionButton
          as="div"
          p={0}
          style={{
            border: 'none',
            cursor: 'pointer',
          }}
          _hover={{
            bgColor: 'none',
          }}
        >
          <Flex gridGap="4" align="center" w="100%" color="gray.700">
            {icon && <Icon as={icon} fontSize="20px" />}
            <Text fontWeight="medium" fontSize="14px">
              {label}
            </Text>
            <AccordionIcon color="gray.700" />
          </Flex>
        </AccordionButton>
        <AccordionPanel
          pt={4}
          pb={1}
          w="100%"
          as="div"
          display="flex"
          ml={6}
          flexDir="column"
          gridGap={4}
          fontWeight="medium"
        >
          {children}
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};
